import { render, staticRenderFns } from "./StepHeader.vue?vue&type=template&id=da96f26a&scoped=true"
import script from "./StepHeader.vue?vue&type=script&lang=js"
export * from "./StepHeader.vue?vue&type=script&lang=js"
import style0 from "./StepHeader.vue?vue&type=style&index=0&id=da96f26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da96f26a",
  null
  
)

export default component.exports